module.exports = __webpack_public_path__ + "static/media/g2.1460cd31.png";